module.exports = __webpack_public_path__ + "static/media/proyectos.2e6a32d3.jpg";